import { SubscriberInfo } from 'src/app/model/AccountModel';
import { Component, OnInit } from '@angular/core';
import { ArchwizardModule } from 'angular-archwizard';
import { ToastrService } from 'ngx-toastr';
import { UserModel } from 'src/app/model/UserModel';
import { Router } from '@angular/router';
import { ProductService } from 'src/app/services/product.service';
import { SharedService } from 'src/app/services/shared.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AccountService } from 'src/app/services/account.service';
import { DataServiceService } from 'src/app/services/data-service.service';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';
import { LteActiveSession } from 'src/app/model/LteActiveSessions';

@Component({
  selector: 'app-changepwd',
  templateUrl: './changepwd.component.html',
  styleUrls: ['./changepwd.component.css']
})
export class ChangepwdComponent implements OnInit {

  defaultpassword:string ="";
  newpassword:string="";
  confirmpassword:string="";
  pwddisable :boolean=false;
  FirstName:string ;
  currentUser: UserModel;
  activeProducts: LteActiveSession[];
  accType: any;
  firstMDN:string;
  firstAccountName:string;

  current = 0;

  constructor( private toastrService:ToastrService,
    private router: Router, private sharedService: SharedService, 
    private productService: ProductService, private authenticationService: AuthenticationService, private accountService: AccountService,
     private dataService: DataServiceService) { 


      

      this. currentUser  = JSON.parse(sessionStorage.getItem('currentUser'));
      if(!this.currentUser)
      {
        this.router.navigate(['/signin']); 

      }

      this.FirstName = this.currentUser.FirstName;
   
      this.fetchAccounts();

      

     }

  ngOnInit() {
  }

  pre(): void {
    this.current -= 1;
  }

  next(): void {
    
    if(this.current==1)
    {

      var val : boolean = this.validatePassword();
      if (!val)
      {
        return;
      }
    

    }

    
    this.current += 1;
    //this.changeContent();
  }
  validatePassword(): boolean{

    
     var retVal :boolean= true;
    if (!this.newpassword || !this.confirmpassword || !this.defaultpassword)
    {
      this.toastrService.error('validation errors');
      retVal = false;

    }
    if (this.confirmpassword != this.newpassword)
    {
      this.toastrService.error('New Password and confirm password do not match');
      retVal = false;

    }
  
    this.pwddisable = retVal;
   return  retVal;


  }

   finishFunction ():boolean
  {
    var  retVal: boolean  = false;
    var user = this.currentUser;

  
    var defaultpassword:boolean=false;

    this.accountService.SetPasswordr(user.UserID, this.newpassword, defaultpassword,user.i_Account).subscribe(    
      data => {    
            
        if(data.Status==1)    
        {       
          this.current += 1;
          retVal = true;
          this.toastrService.info("Password changed succesfully");
      
          
         
        }    
        else{   
       

          retVal = false;
        }    
      },     
      error => {    
         
   
      });    
  
    return retVal;


  }

  moveAway()
  {


    sessionStorage.clear();
    this.router.navigate(['/signin']); 

  }
  async fetchAccounts() {

    var my_object = this.currentUser;
    let activeSessionRequest: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    activeSessionRequest.DownloadType = "ACC:GetDetail";

    if (my_object) {
      var iAccount = parseInt(my_object.i_Account);

      if (iAccount == 0)   //  customer with multiple accounts
      {
        //an individual
        activeSessionRequest.i_customer = parseInt(my_object.i_Customer);
        await this.setActiveSession(activeSessionRequest);

      }
      else  // single account
      {
        activeSessionRequest.i_account = parseInt(my_object.i_Account);
        this.setActiveSession(activeSessionRequest);
      }

    }
  }

  async setActiveSession(model: ActiveSessionsReqObj) {

    if (model) {
      let res = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();
      if (!res.Result) {
        this.toastrService.error("An error occured, Couldn't get active sessions", "Error");
        return;
      }
      let activeSessions : LteActiveSession[]=[] as LteActiveSession[];

      if (this.accType == "VOICE") {
        activeSessions = <LteActiveSession[]>  res.Result.filter(a => a.Product.Name.toLowerCase().includes("voice")).slice(0,3);
      } else {
        activeSessions = <LteActiveSession[]>  res.Result.filter(a => !a.Product.Name.toLowerCase().includes("voice")).slice(0,3);;
      }

     
      this.activeProducts = activeSessions;
      var firstAcc = this.activeProducts[0];
      this.firstMDN = firstAcc.ID;
      this.firstAccountName = firstAcc.subscriber.FirstName;
       
      
       

   

    }
  }

}
